import { uiStore } from "@/store/store";
import { toggleAndSetPanelStateToAdvanced } from "./util";

export function openElementClassAutocompleteAndFocusIt() {
  uiStore.setKeyboardTriggeredActions({
    ...uiStore.keyboardTriggeredActions,
    openClassesDropdown: "pending"
  });

  toggleAndSetPanelStateToAdvanced();
}
